import { useAuth } from "@/contexts/AuthContext";
import { Info } from "lucide-react";
import FilesPanel from "@/pages/shared/espace/FilesPanel";

const DOC_CATEGORIES = ["Emploi du temps", "Planification", "Progression", "Programme officiel", "Note de service", "Guide pédagogique", "Autre"];

export default function Documentation() {
  const { user } = useAuth();
  const canUpload = ["admin", "directeur"].includes(user?.role);
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-2 text-sm text-[#5C736A] bg-white border border-[#E2E8F0] rounded-lg p-3">
        <Info className="w-4 h-4 mt-0.5 text-[#1F7A63] shrink-0" />
        {canUpload
          ? (user?.role === "admin"
            ? "Les documents que vous publiez ici sont visibles par tous les enseignants de la plateforme."
            : "Les documents que vous publiez ici sont visibles par les maîtres de votre école.")
          : "Emplois du temps, planifications et documents officiels partagés par l'administration et votre direction."}
      </div>
      <FilesPanel scope="doc" canUpload={canUpload} categories={DOC_CATEGORIES} emptyText="Aucun document publié pour le moment." />
    </div>
  );
}
